import { Common } from "@components/common/CommonTypes";
import { Index } from "@components/index/IndexTypes";
import { ComponentElem } from "@components/interfaces";
import PickDateRange, { PickDateRangeResult } from "./PickDateRange";
import PopupBase from "./PopupBase";
import Popups from "./Popups";
import ValueSelector, { ValueSelectorResult } from "./ValueSelector";
import PatternSamples from "@root/ts/PatternSamples";
import EZAlert from "./EZAlert";
import FormTools from "@root/ts/FormTools";
import GS from "@root/ts/GlobalSetting";
import { Search } from "../search/SearchTypes";
import { SearchSyncExtraInput, SetupExtraSerachFilters } from "../search/SearchFilter";
import { Emitter } from "strict-event-emitter";
import gsap from "gsap";
import RadioSelect from "../ui/checkboxs/RadioSelect";
import ValueRange from "../ui/inputs/ValueRange";
import SearchManager, { generateSearchQuery } from "../search/SearchManager";
import { SearchSyncCommonInput } from "../search/SearchSearchbar";
import ApiProxy from "../../ts/ApiProxy";

export default class SearchPopup extends PopupBase
{
  static instance: SearchPopup;

  autoClose_popup: boolean = true;
  popupAlign = 8;

  startDate: moment.Moment;
  endDate: moment.Moment;

  _keywordInputElem: HTMLInputElement;
  _dateInputElem: HTMLInputElement;
  _sortInputElem: HTMLInputElement;

  _isSimpleMode: boolean = true;

  _priceSetting: Search.Price;

  _timeRadio: RadioSelect;
  _siteRadio: RadioSelect;
  _priceRange: ValueRange;

  input: Search.SearchInput = {};

  emitter: Emitter<{ change: [type: Search.SearchInputTypes], requestSearch: [] }>;

  constructor(elem: ComponentElem)
  {
    super(elem);

    SearchPopup.instance = this;

    this.emitter = new Emitter();

    this._setupKeywordInput();
    this._setupSortInput();
    this._setupDateInput();

    this.$root.find(".cover-block").on("click", (event: Event) =>
    {
      event.preventDefault();
      Popups.to("search-popup");
    });

    this.$root.find(".btn-search").on("click", (event: JQuery.ClickEvent) =>
    {
      event.preventDefault();


      if (this._isSimpleMode) {

        let formData = this.getFormData();

        if (formData) {
          // console.log(formData);

          let obj =
          {
            "keyword": formData["keyword"],
            "sort": formData["sort"],
            "start-date": formData["start_date"],
            "end-date": formData["end_date"],
          };

          let query = generateSearchQuery(obj);
          window.location.href = ApiProxy.getCommonPageData().search_page_path + "?" + query;

          // FormTools.sendForm("common/search", formData, undefined, { schema: schema, exampleIndex: 0 }).then((result) =>
          // {
          //   FormTools.handleNextUrl(result);
          // }).catch(() =>
          // {
          //   this.toMe();
          // });
        }

      }
      else {
        Popups.close().then(()=>
        {
          this.emitter.emit("requestSearch");
        });
      }
    });
  }

  syncInput(input: Search.SearchInput)
  {
    this.input = Object.assign({}, input);
    delete this.input.page_index;
    
    SearchSyncCommonInput.call(this, input);
    SearchSyncExtraInput.call(this, input);
  }

  toMeAsMode(mode: "default" | "extra"): void
  {
    Popups.to("search-popup").then(() =>
    {
      let $fields = this.$root.find(".fields"),
        targetId = mode === "default" ? "#common-fields" : "#extra-fields";
      gsap.to($fields[0], { scrollTo: targetId });
    });
  }

  getFormData()
  {
    let keyword = this._keywordInputElem.value;

    if (!PatternSamples.simple.test(keyword)) {
      EZAlert.alert("請輸入城市、景點或活動名稱", undefined, false, true).then(() =>
      {
        this.toMe();
      });

      return false;
    }
    else {
      this.input.keyword = keyword;
      return this.input;
    }
  }

  activeExtraFilter(priceSetting: Search.Price, siteSetting: string[])
  {
    this._priceSetting = priceSetting;

    this._isSimpleMode = false;
    this.$root.find(".keyword-title").attr("is-required", "false");

    this.$root.attr("simple-mode", "false");

    SetupExtraSerachFilters(this, priceSetting, siteSetting);
  }


  _setupKeywordInput()
  {
    this._keywordInputElem = this.$root.find(`[data-target="keyword"] input`)[0] as HTMLInputElement;
    this._keywordInputElem.value = "";

    this._keywordInputElem.addEventListener("input", () =>
    {
      let value = this._keywordInputElem.value;
      this.input.keyword = (PatternSamples.simple.test(value)) ? value : "";
    });
  }

  _setupSortInput()
  {
    let self = this,
      $btn = this.$root.find(`.bar[data-target="sort"]`),
      input = this._sortInputElem = $btn.find(`input`)[0];

    let valueList = Common.getSortValueList();

    $btn.on("click", (event: Event) =>
    {
      event.preventDefault();
      // Popups.openAsDropdown("value-selector", $btn[0]);
      ValueSelector.instance.show(valueList, null, "search-popup").then((result?: ValueSelectorResult) =>
      {
        if (result) {
          let data: Common.SortData = result.value;

          input.value = data.name;
          self.input.sort = data.name;
        }
      })
    });
  }

  _setupDateInput()
  {
    let $field = this.$root.find('[data-target="date"]'),
      input: HTMLInputElement = this._dateInputElem = $field.find("input")[0];

    input.maxLength = GS.search.keywordMaxLength;
    input.value = "";

    $field.on("click", (event: Event) =>
    {
      event.preventDefault();

      PickDateRange.instance.request(null, this.startDate, this.endDate, "search-popup").then((result: PickDateRangeResult) =>
      {
        if (!result) return;

        if (result.isReset) {
          this.startDate = null;
          this.endDate = null;
        }
        else {
          this.startDate = result.start;
          this.endDate = result.end;

          this.input.start_date = result.start.format(GS.DATE_FORMAT);
          this.input.end_date = result.end.format(GS.DATE_FORMAT);
        }

        this._updateDateText();
      });

    });
  }

  _updateDateText()
  {
    if (this.startDate && this.endDate) {
      this._dateInputElem.value = SearchManager.getDateText(this.startDate, this.endDate);
    }
    else {
      this._dateInputElem.value = "";
    }
  }
}